import { Pipe, PipeTransform } from '@angular/core';
import { formatFieldName } from '../../utils/text-formatter';

@Pipe({
  name: 'formatFieldName',
  standalone: true
})
export class FormatFieldNamePipe implements PipeTransform {
  transform(value: string): string {
    return formatFieldName(value);
  }
}
